import React, { useState } from "react";
import "../styles/Tooltip.scss";

const Tooltip = ({ children, content, position = "top", disabled = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => {
    if (!disabled) setIsVisible(true);
  };
  const hideTooltip = () => setIsVisible(false);

  return (
    <span className="tooltip-container">
      <span
        className="tooltip-trigger"
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
      >
        {children}
      </span>
      {isVisible && !disabled && (
        <span className={`tooltip tooltip--${position}`}>
          <span className="tooltip__content">{content}</span>
        </span>
      )}
    </span>
  );
};

export default Tooltip;
